Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.TriangleCulling = module.exports.default = {
	NEGATIVE: "negative",
	NONE: "none",
	POSITIVE: "positive"
};